import { SessionDTO } from "@/core/domain/dto/security/session.dto";
import { SessionService } from "@/core/services/security/session.service";
import { MessagesUtils } from "@/core/utils/layout/messages.utils";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    RouterStateSnapshot,
    UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class PrivateRouteGuard implements CanActivate {
    constructor(
        private sessionService: SessionService,
        private messagesUtils: MessagesUtils
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | boolean
        | UrlTree
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree> {
        const session: SessionDTO = this.sessionService.getInstance();
        if (!session.isLogged) {
            this.sessionService.logout();
            this.messagesUtils.clear();
            setTimeout(() => {
                this.messagesUtils.showMessageErrorToast(
                    "messages.error.userNotAuthenticated",
                );
            }, 300);
        }
        return session.isLogged;
    }
}
